import { render, staticRenderFns } from "./LastOrders.vue?vue&type=template&id=29bb5f34&"
import script from "./LastOrders.vue?vue&type=script&lang=js&"
export * from "./LastOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29bb5f34')) {
      api.createRecord('29bb5f34', component.options)
    } else {
      api.reload('29bb5f34', component.options)
    }
    module.hot.accept("./LastOrders.vue?vue&type=template&id=29bb5f34&", function () {
      api.rerender('29bb5f34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/LastOrders.vue"
export default component.exports